import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1B2B5E] text-white pt-16 pb-8 border-t-4 border-[#F5A623]" data-id="element-44">
      <div className="container mx-auto px-4 md:px-6" data-id="element-45">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-46">
          {/* Brand */}
          <div className="flex flex-col items-start" data-id="element-47">
            <img src="https://cdn.magicpatterns.com/uploads/dFenca9YduCaDD5NbDBKDV/Imagotipo_-_Las_Palmas.png" alt="Las Palmas Cargo Logistic LLC" className="h-16 object-contain bg-white p-2 rounded-lg mb-6" data-id="element-48" />
            <p className="text-gray-300 text-sm max-w-xs" data-id="element-49">
              Tu carga en buenas manos, de Miami a Venezuela. Envíos aéreos y
              marítimos confiables.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-50">
            <h4 className="text-lg font-bold mb-6 text-[#F5A623]" data-id="element-51">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-52">
              <li data-id="element-53">
                <a href="#servicios" className="text-gray-300 hover:text-white transition-colors" data-id="element-54">
                  Servicios
                </a>
              </li>
              <li data-id="element-55">
                <a href="#como-funciona" className="text-gray-300 hover:text-white transition-colors" data-id="element-56">
                  ¿Cómo funciona?
                </a>
              </li>
              <li data-id="element-57">
                <a href="#nosotros" className="text-gray-300 hover:text-white transition-colors" data-id="element-58">
                  Nosotros
                </a>
              </li>
              <li data-id="element-59">
                <a href="#contacto" className="text-gray-300 hover:text-white transition-colors" data-id="element-60">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Info & Social */}
          <div data-id="element-61">
            <h4 className="text-lg font-bold mb-6 text-[#F5A623]" data-id="element-62">
              Información Legal
            </h4>
            <p className="text-gray-300 mb-6 flex items-center gap-2" data-id="element-63">
              <span role="img" aria-label="USA Flag" data-id="element-64">
                🇺🇸
              </span>{' '}
              Empresa registrada en Florida, USA
            </p>

            <div className="flex gap-4" data-id="element-65">
              <a href="https://www.instagram.com/laspalmascargo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F5A623] hover:text-[#1B2B5E] transition-all" data-id="element-66">
                <Instagram size={20} data-id="element-67" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400" data-id="element-68">
          <p data-id="element-69">
            © 2025 Las Palmas Cargo Logistic LLC. Todos los derechos
            reservados.
          </p>
          <p data-id="element-70">Diseñado con ❤️ para la comunidad venezolana</p>
        </div>
      </div>
    </footer>;
}